const wrapper = "_ibqw1dkgg56";
const switchWrapper = "_ibqsdf4dsz";
const contentWrapper = "_ibqcgpeclu";

export { contentWrapper, switchWrapper, wrapper };
import "./provider.course-revision-printers.style.linaria.module.css";
//# sourceMappingURL=provider.course-revision-printers.style.js.map
